var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGovern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#b0b0b0",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17 7h-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 11h-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 15h-5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m19 2h-14c-1.10457 0-2 .89543-2 2v15.1543c0 1.3853 1.37412 2.351 2.67744 1.8818l1.56176-.5622c.48801-.1757 1.02519-.1549 1.49817.0579l2.44193 1.0989c.5219.2348 1.1195.2348 1.6414 0l2.4419-1.0989c.473-.2128 1.0102-.2336 1.4982-.0579l1.5618.5622c1.3033.4692 2.6774-.4965 2.6774-1.8818v-15.1543c0-1.10457-.8954-2-2-2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovern);
export default __webpack_public_path__ + "static/media/govern.76975a7269b803b1f982de721cad195f.svg";
export { ForwardRef as ReactComponent };